import { MediaRef } from "@/app/features/shared/__to_be_integrated/types/general/media/media";
import { mediaRefName, mediaRefType, mediaRefUrl } from "@/app/features/shared/__to_be_integrated/types/general/media/media-helper";
import Image from "next/image";
import PDFView from "@/app/features/shared/media-view/ui/shared/media-views/PDFView";

export function renderMedia(media: MediaRef, onLoad?: () => void) {
    const mediaUrl = mediaRefUrl(media, { size: 'small' });
    const mediaAlt = mediaRefName(media) || '';
    const mediaType = mediaRefType(media);

    switch (mediaType) {
        case 'image':
            return (
                <Image
                    src={mediaUrl}
                    alt={mediaAlt}
                    fill
                    sizes="(max-width: 768px) 100vw, 25vw"
                    className="object-cover z-1"
                    onLoad={onLoad}
                />
            );
        case 'video':
            return (
                <div className="absolute left-0 right-0 top-0 bottom-0 flex items-center justify-center">
                    <video
                        src={mediaUrl}
                        preload="auto"
                        className="flex flex-auto w-full h-full object-contain"
                        onLoad={onLoad}
                    >
                        <source src={mediaUrl} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            );
        case 'pdf':
            return (
                <div className="absolute left-0 right-0 top-0 bottom-0 flex items-center justify-center">
                    <PDFView
                        src={mediaUrl}
                        onLoad={onLoad}
                        clickToOpen={false}
                    />
                </div>
            )
    }
}